// Webpack Imports
import * as bootstrap from "bootstrap";

(function () {
  "use strict";

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });

 
})();

const singleProdView = document.querySelector(".single-prod-view");
const buttonsProds = document.querySelectorAll(".buttons-prods");

if (singleProdView && buttonsProds.length > 0) {
  const singleProdViewWidth = singleProdView.offsetWidth;

  buttonsProds.forEach((button) => {
    button.style.width = singleProdViewWidth + "px";
  });
}

// $('.owl-carousel').owlCarousel({
// 	loop: true,
// 	autoplay: true,
// 	autoplaySpeed: 1000,
// 	autoplayTimeout: 2500,
// 	autoplayHoverPause: true,
// 	animateOut: 'fadeOut',
// 	animateIn: 'fadeIn',
// 	items: 1,
// 	smartSpeed: 500,
// 	fluidSpeed: 500,
// 	dragEndSpeed: 500,
// 	nav: false,
// 	dots: false,
// 	responsive: {
// 		0: {
// 			items: 4
// 		},
// 		600: {
// 			items: 5
// 		},
// 		1000: {
// 			items: 5
// 		}
// 	}
// })

jQuery(document).ready(function ($) {
  $('[data-action="add-to-cart"]').on("click", function (e) {
    let buttonAdc = $(this);
    console.log("click");
    e.preventDefault();

    let products = $("[data-product]").each(function (index) {
      // let products = $('input[name^="quantity"]').each(function() {
      let element = $(this);
      let elementId = element.data("product");
      let quantity = element.find('input[name^="quantity"]');
      let quantityVal = quantity.val();

      let data = {
        action: "woocommerce_ajax_add_to_cart",
        product_id: elementId,
        quantity: quantityVal,
      };

      if (quantityVal > 0) {
        //  $(document.body).trigger('adding_to_cart', [buttonAdc, data]);
        setTimeout(function () {
          $.ajax({
            url:
              wc_add_to_cart_params.ajax_url +
              "?hash=" +
              elementId +
              Date.now(),
            type: "POST",
            cache: false,
            data: data,
            beforeSend: function (response) {
              // buttonAdc.removeClass('added').addClass('loading');
            },
            complete: function (response) {
              // buttonAdc.addClass('added').removeClass('loading');
              $("#recentProductModal").modal("show");
              $(document.body).trigger("wc_fragment_refresh");
            },
            success: function (response) {
              if (response.error & response.product_url) {
                window.location = response.product_url;
                return;
              } else {
                //  $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, buttonAdc]);
              }
            },
          });
        }, 1000 * index);
      }
    });
  });
});


addEventListener("DOMContentLoaded", (event) => {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('.tool-collapse')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  });